function DetailsLink({ url }) {
  return (
    <a className="fs-12 d-b ta-r" href={url} target="_blank">
      Ver lista
    </a>
  );
}

DetailsLink.propTypes = {
  url: React.PropTypes.string.isRequired
};

module.exports = DetailsLink;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/details-link.jsx